// Types
import { BrandProps } from './Brand.types';
import { HeadingProps } from '@components/heading/Heading.types';

// Components
import Heading from '@components/heading';

export const Brand = ({ brand, headingTag = 'h4' }: BrandProps) => {
  if (!brand) {
    return null;
  }

  const headingProps: HeadingProps = {
    marginBottom: '1',
    tag: headingTag,
    type: 'xs',
  };

  return <Heading {...headingProps} label={brand} />;
};

export default Brand;
